/* Jane Lushka — sticky add-to-cart controller (mobile).
   1) Visibility: the bar stays hidden until the inline ADD button scrolls above the viewport.
   2) ADD: proxies a click to the inline product-form's ADD (reuses the existing AJAX add).
   3) Size: a bottom-sheet whose options set the MAIN variant radio + dispatch `change`, so the
      theme's existing <variant-radios> updates the variant id (incl. the sticky form), price,
      and availability. We only mirror the bar's own size label + ADD state. */
(function () {
  'use strict';

  function cssEsc(s) {
    return (window.CSS && CSS.escape) ? CSS.escape(s) : String(s).replace(/(["\\])/g, '\\$1');
  }

  /* Mirror the server-rendered top-price low-stock ("Only N left in stock") into the
     size-chart-row slot. The source lives INSIDE the real top price block
     (.product__price .jl-low-stock), which the theme's variant-change section-render keeps
     correct per selected size. We read the *real* top price (NOT the sticky bar's #price
     copy — both share id="price-{section}"), and copy its HTML into [data-jl-low-stock-slot].
     If the source is absent (variant above threshold / not tracked), we clear + hide the slot. */
  function syncLowStock() {
    var slot = document.querySelector('[data-jl-low-stock-slot]');
    if (!slot) return;
    var src = document.querySelector('.product__price .jl-low-stock');
    var html = src ? src.innerHTML.trim() : '';
    if (html) {
      slot.innerHTML = html;
      slot.hidden = false;
    } else {
      slot.textContent = '';
      slot.hidden = true;
    }
  }

  function init() {
    /* Low-stock mirror is independent of the sticky bar — wire it up first so it works
       even on viewports/products where the bar isn't present.
       NOTE: variants.js dispatches `variant-change` SYNCHRONOUSLY, *before* its async
       section-render fetch swaps #price — listening to that event reads the previous
       variant's value (one size behind). Instead, observe the real top price block: the
       MutationObserver fires exactly when variants.js does `#price.innerHTML = ...`, i.e.
       when the fresh low-stock has actually landed. */
    syncLowStock();
    var priceEl = document.querySelector('.product__price');
    if (priceEl && 'MutationObserver' in window) {
      new MutationObserver(syncLowStock).observe(priceEl, { childList: true, subtree: true });
    }

    var bar = document.querySelector('[data-sticky-atc]');
    if (!bar) return;

    var inlineAdd = document.querySelector('.jl-buy [name="add"]');
    var stickyAdd = bar.querySelector('[data-sticky-add]');
    var stickyAddLabel = bar.querySelector('[data-sticky-add-label]');
    var label = bar.querySelector('[data-size-label]');
    var trigger = bar.querySelector('[data-size-trigger]');
    var sheet = bar.querySelector('[data-size-sheet]');
    var sizeName = bar.getAttribute('data-size-name');

    /* 1) scroll-triggered visibility */
    if (inlineAdd && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var scrolledPast = e.boundingClientRect.top < 0; // inline ADD is above the viewport
        var show = !e.isIntersecting && scrolledPast;
        bar.classList.toggle('is-visible', show);
        document.body.classList.toggle('jl-atc-visible', show); // floats the Gorgias launcher up with the bar
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      }, { threshold: 0 }).observe(inlineAdd);
    }

    /* 2) sticky ADD -> inline ADD */
    if (stickyAdd && inlineAdd) {
      stickyAdd.addEventListener('click', function () {
        if (stickyAdd.hasAttribute('disabled')) return;
        inlineAdd.click();
      });
    }

    /* 3) bottom sheet */
    function mark(value) {
      if (!sheet) return;
      sheet.querySelectorAll('[data-size-option]').forEach(function (o) {
        o.classList.toggle('is-selected', o.getAttribute('data-option-value') === value);
      });
    }
    function setSheet(open) {
      if (!sheet) return;
      if (open) {
        sheet.hidden = false;
        requestAnimationFrame(function () { sheet.classList.add('is-open'); });
        document.body.classList.add('jl-sheet-open');
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
      } else {
        sheet.classList.remove('is-open');
        document.body.classList.remove('jl-sheet-open');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        setTimeout(function () { if (!sheet.classList.contains('is-open')) sheet.hidden = true; }, 350);
      }
    }
    if (trigger) trigger.addEventListener('click', function () { setSheet(true); });
    if (sheet) {
      sheet.querySelectorAll('[data-size-sheet-close]').forEach(function (el) {
        el.addEventListener('click', function () { setSheet(false); });
      });
      sheet.querySelectorAll('[data-size-option]').forEach(function (opt) {
        opt.addEventListener('click', function () {
          if (opt.getAttribute('aria-disabled') === 'true') return;
          var value = opt.getAttribute('data-option-value');
          if (sizeName) {
            var target = null;
            document.querySelectorAll('variant-radios input[name="' + cssEsc(sizeName) + '"]').forEach(function (r) {
              if (r.value === value) target = r;
            });
            if (target) {
              target.checked = true;
              target.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
          if (label) label.textContent = value;
          mark(value);
          setSheet(false);
        });
      });
    }

    /* init the bar's size label from the currently-checked radio */
    if (sizeName) {
      var checked = document.querySelector('variant-radios input[name="' + cssEsc(sizeName) + '"]:checked');
      if (checked) { if (label) label.textContent = checked.value; mark(checked.value); }
    }

    /* 4) keep label + sticky ADD state in sync when the variant changes */
    document.addEventListener('variant-change', function (ev) {
      var v = ev.detail && ev.detail.variant;
      if (sizeName && label) {
        var c = document.querySelector('variant-radios input[name="' + cssEsc(sizeName) + '"]:checked');
        if (c) { label.textContent = c.value; mark(c.value); }
      }
      if (!stickyAdd) return;
      var strings = window.variantStrings || {};
      if (v && v.available) {
        stickyAdd.removeAttribute('disabled');
        if (stickyAddLabel) stickyAddLabel.textContent = strings.addToCart || 'Add to cart';
      } else {
        stickyAdd.setAttribute('disabled', 'disabled');
        if (stickyAddLabel) stickyAddLabel.textContent = strings.soldOut || 'Sold out';
      }
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
